import React from 'react';
import Header from '../components/Header';
import { useParams } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Text from '../components/LikertLanguageText';

// URL for API
const URL = 'https://quiz5ll-server.herokuapp.com';
//const URL = 'http://localhost:8080';
//const URL = '';

let initialScores = [
    {
        name: 'proximity',
		score: -1,
		pole: 'autonomy'
    },
    {
        name: 'recognition',
		score: -1,
		pole: 'feedback'
    },
    {
        name: 'purpose',
		score: -1,
		pole: 'performance'
    },
    {
        name: 'connection',
		score: -1,
		pole: 'boundaries'
    },
    {
        name: 'mentoring',
		score: -1,
		pole: 'empowerment'
    },
    {
        name: 'feedback',
		score: -1,
		pole: 'recognition'
    },
    {
        name: 'autonomy',
		score: -1,
		pole: 'proximity'
    },
    {
        name: 'performance',
		score: -1,
		pole: 'purpose'
    },
    {
        name: 'empowerment',
		score: -1,
		pole: 'mentoring'
    },
    {
        name: 'boundaries',
		score: -1,
		pole: 'connection'
    }
];
function Result() {
    const [scores, setScores] = React.useState([]);
	const [chart, setChart] = React.useState([]);
	const [sortedChart, setSortedChart] = React.useState([]);
	const [selectedTop, setSelectedTop] = React.useState(0);
	const [selectedBar, setSelectedBar] = React.useState(null);
	const [selectedLanguage, setSelectedLanguage] = React.useState(null);
	const [selectedScore, setSelectedScore] = React.useState(0);
    const { id } = useParams();

	const handleBarClick = (index, value, lang) => {
		console.log('bar', index, lang);
		setSelectedBar(index);
		setSelectedLanguage(lang);
		setSelectedScore(value);
		setSelectedTop(null);
	}
	const handleTopClick = (index, value, lang) => {
		console.log('top', index, lang);
		setSelectedTop(index);
		setSelectedLanguage(lang);
		setSelectedScore(value);
		setSelectedBar(null);
	}
	// call once
    if (scores.length === 0) {
        // get quiz results
        fetch(`${URL}/likert/result/${id}`, {
            method: 'get',
        })
            .then(res => res.json())
            .then(
                (r) => {
                    console.log('r', r.result);
                    const chartArr = [];
                    initialScores.forEach((row, index) => {
                        chartArr.push({
                            id: row.name,
                            language: row.name.charAt(0).toUpperCase() + row.name.slice(1),
							value: r.result[row.name],
							pole: row.pole,
							pole_value: 0
                        });
                        chartArr[chartArr.length - 1][row.name.charAt(0).toUpperCase() + row.name.slice(1)] = r.result[row.name];
	                    row.score = r.result[row.name];                         
					});
					// sort
					const sortedScores = initialScores.sort((a, b) => b.score - a.score);					
					const sortedChart = chartArr.sort((a, b) => b.value - a.value);
					
					// set intial
					setSelectedLanguage(sortedChart[0].language);
					setSelectedScore(sortedChart[0].value);
					for (let i = 0;i < sortedChart.length; i += 1) {
						const pole = sortedChart[i].pole;
						for (let j = 0; j < sortedChart.length; j += 1) {
							if (sortedChart[j].id === pole) {
								sortedChart[i].pole_value = sortedChart[j].value;
								break;
							}
						}
					}
					// ensure chart has each set of pairs
					const pairs = { connection: 0, recognition: 0, purpose: 0, mentoring: 0, proximity: 0};
					const pairedChart = [];
					for (let i = 0; i < sortedChart.length; i += 1) {
						if (pairs[sortedChart[i].id]  === 0) {
							pairs[sortedChart[i].id] = 1;
							pairedChart.push(sortedChart[i]);
						}
					}
                    console.log('chart', sortedChart);
                    setScores(sortedScores);
					setChart(pairedChart);
					setSortedChart(sortedChart);
                },
                (error) => {
                    console.log('ERROR', error);
                }
            )
    }
    if (scores.length === 0) {
        return (
            <>
                <Header />
                <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
                    <CircularProgress disableShrink />
                </div>
            </>
        )
    }

    return (
      <>
        <Header />
        <div className="instructions">
          	<div className="container">
			  <div style={{ fontSize: '21px', fontWeight: '400'}}>
                    Your top leadership language is <b>{scores[0].name.charAt(0).toUpperCase() + scores[0].name.slice(1)}</b>
               </div>
          	</div>

        </div>
		<div class="container" style={{ height: '400px', marginTop: '20px'}}>
			<Grid container>
				<Grid item xs={12} sm={6} style={{textAlign: 'center'}}>
					<>
						<div style={{fontSize: '17px', fontWeight: '700', marginBottom: '20px'}}>
							Your Top 3 Leadership Languages
							<div style={{ color: '#999', fontSize: '11px', fontWeight: '400'}}>
								Click on a language to see detail
							</div>
						</div>

						{ 
							sortedChart.map((row, index) => {
								if (index <= 2) {
									return (
										<div style={{ padding: '5px', borderRadius: '7px', backgroundColor: selectedTop === index ? '#f1f1f1' : '#fff', marginBottom: '20px', textAlign:'left', cursor: 'pointer'}} onClick={v => handleTopClick(index, row.value, row.language)}>
											<span style={{fontSize: '14px', fontWeight: '500', marginRight: '10px'}}>{index + 1}.</span>
											<span style={{ fontSize: '21px'}}>
												<b>{row.language}</b>
												<span style={{ marginLeft: '10px', display: 'none', fontSize: '14px'}}>
													(with a score of <b>{row.value}</b>)
												</span>
											</span>
										</div>
									);	
								}
							})	
						}
					</>
				</Grid> 
				<Grid item xs={12} sm={6} style={{textAlign: 'center'}}>
					<>
						<div style={{fontSize: '17px', fontWeight: '700', marginBottom: '20px'}}>
						Breakdown of scores across all Leadership Languages
						<div style={{ color: '#999', fontSize: '11px', fontWeight: '400'}}>
								Click on a bar to see detail
							</div>
						</div>
						{ 
							chart.map((row, index) => {
								console.log('ROW', row, index);
								return (
									<div style={{ display: 'block', marginBottom: '20px'}}>
										<div>
											<div class="bar-text-left">{row.language} (<b>{row.value}</b>)</div>
											<div class="bar-text-right">{row.pole.charAt(0).toUpperCase() + row.pole.slice(1)} (<b>{row.pole_value}</b>) </div>
										</div>
										<div class="left-result" style={{ backgroundColor: selectedBar === index ? '#ccc' : '#BBDEFB' }} onClick={v => handleBarClick(index, row.value, row.language)}>
											<div class="left-bar" style={{  width:`${row.value * 1.1}px`, backgroundColor: selectedBar === index ? '#ccc' : '#1E88E5'}}  />
										</div>
										<div class="right-result" style={{ backgroundColor: selectedBar === (index + 5) ? '#ccc' : '#BBDEFB' }} onClick={v => handleBarClick((index  + 5), row.pole_value, row.pole.charAt(0).toUpperCase() + row.pole.slice(1))}>
											<div class="right-bar" style={{  width:`${row.pole_value * 1.1}px`, backgroundColor: selectedBar === index + 5 ? '#ccc' : '#1E88E5'}}  />
										</div>
			
									</div>
								);	
							})	
						}
					</>
				</Grid> 
			</Grid>
			<div className="container" style={{ marginTop: '10px', borderTop: '1px solid #ddd'}}>
				<div style={{ padding: '10px', marginTop: '10px' }}><Text language={selectedLanguage} score={selectedScore}  /></div>
			</div>

		</div>
      </>
    );
}

export default Result;
